export default {
  id: 13,
  logo: require('@/assets/rocket.svg'),
  name: 'delivery ia',
  subtitle: 'Décuplez la capacité de votre Feature Team avec l\'IA',
  description: {
    details: `L'intelligence artificielle ne se résume pas à un simple "agent de commit" :
      c'est un <b>changement de paradigme</b> qui s'intègre à toute la <b>chaîne de delivery</b>,
      de la captation du besoin jusqu'à la mise en service réelle. Cette formation apprend
      à votre <b>Feature Team</b> (PO, QA, Tech Leads, Développeurs) à prendre de la hauteur.
      L'objectif n'est pas de supprimer des postes, mais d'<b>augmenter radicalement la
      capacité</b> de l'équipe pour accomplir, à effort constant, des projets autrefois
      inenvisageables.`,
    goals: [
      {
        id: 1,
        content: 'Penser "chaîne de delivery" globale, du pré-cadrage du PO à la sécurisation en production'
      },
      {
        id: 2,
        content: 'Maîtriser le vocabulaire technique de l\'IA (skills, hooks, harnais) pour définir ses besoins'
      },
      {
        id: 3,
        content: 'Développer un esprit critique et savoir contredire une machine trop sûre d\'elle'
      },
      {
        id: 4,
        content: 'Créer et orchestrer des agents personnalisés pour accélérer le time to market'
      }
    ],
    needs: [
      {
        id: 1,
        title: 'PUBLIC',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/cto.svg'), name: 'Product Owner' },
          { id: 2, logo: require('@/assets/training/generalKnoledge.svg'), name: 'Ingénieur QA' },
          { id: 3, logo: require('@/assets/training/projectLeader.svg'), name: 'Tech Lead' },
          { id: 4, logo: require('@/assets/training/developer.svg'), name: 'Développeur' }
        ]
      },
      {
        id: 2,
        title: 'PÉDAGOGIE',
        items: [
          { id: 1, logo: require('@/assets/training/70percent.png'), name: null }
        ]
      },
      {
        id: 3,
        title: 'PRÉ-REQUIS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/generalKnoledge.svg'), name: 'Connaissance de la chaîne de développement logiciel' },
          { id: 2, logo: require('@/assets/training/experience.svg'), name: 'Pratique des méthodologies de Feature Teams' }
        ]
      },
      {
        id: 4,
        title: 'OUTILS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/claude.svg'), name: 'Claude Code' },
          { id: 2, logo: require('@/assets/training/tools/copilot.svg'), name: 'GitHub Copilot' },
          { id: 3, logo: require('@/assets/training/tools/cursor.svg'), name: 'Cursor / Windsurf' }
        ]
      }
    ],
    time: '2 JOURS'
  },
  program: [
    {
      id: 1,
      title: 'L\'IA COMME ASSISTANT GLOBAL (FONDAMENTAUX ET MINDSET)',
      items: [
        { id: 1, content: 'Démystifier la machinerie : harnais, hooks, skills pour concevoir l\'IA plutôt que la subir' },
        { id: 2, content: 'La philosophie du Delivery Augmenté : penser la vélocité globale de l\'équipe' },
        { id: 3, content: 'Gérer la contradiction : corriger un agent qui valide du code défaillant avec certitude' },
        { id: 4, content: 'Orchestrer l\'intelligence : agents concurrents (métier, bonnes pratiques, juge)' }
      ]
    },
    {
      id: 2,
      title: 'L\'IA ADAPTÉE À CHAQUE RÔLE DE LA FEATURE TEAM',
      items: [
        { id: 1, content: 'Product Owner : pré-cadrage automatisé, création et rédaction des tickets JIRA' },
        { id: 2, content: 'Développeur & Tech Lead : pair-programming, génération de code, agents de commit, documentation' },
        { id: 3, content: 'Qualité (QA) : adapter l\'assurance qualité à une production accélérée' },
        { id: 4, content: 'Sécuriser le passage de la mise en production à la mise en service réelle' }
      ]
    },
    {
      id: 3,
      title: 'ATELIER PRATIQUE "DELIVERY EXCELLENCE"',
      items: [
        { id: 1, content: 'Réflexion stratégique : s\'attaquer aux dettes techniques (legacy, migrations) hors roadmap' },
        { id: 2, content: 'Conception sur mesure : créer ses propres agents pour ses points de friction (ticketing, qualité, review)' },
        { id: 3, content: 'Synergie d\'équipe : identifier les patterns communs pour forger une méthode unifiée' }
      ]
    }
  ]
}
